import K from '../constants';
import restHelpers from '../helpers/restHelper';

const getFn = () => restHelpers.withBearer.get(`${K.API_URL}/service-managers/find-one`, {});

export default {
  get: getFn
};



// WEBPACK FOOTER //
// ./src/services/serviceManager.js